import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import api from './components/services/api';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorHandlers } from './components/services/clientLogger';

installGlobalErrorHandlers();

api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
      config.headers.authorization = `Bearer ${token}`
    }
    return config;
  },
  null,
  { synchronous: true }
);
api.interceptors.response.use((response) => {
  if (response.data.result) {
    const meta = {
      status: response.data.status,
      code: response.data.code,
      message: response.data.message
    }
    response.data = response.data.result
    response.meta = meta
  }
  return response
}

)
ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
